<div class="container-fluid bg-white">
  <div class="row">
    <div class="border border-right col-md-4 col-lg-3 p-0 bg-body-tertiary">
      <div class="d-flex flex-column p-3" style="height: calc(100vh - 64px);">
        <div class="form-floating mb-2">
          <input class="form-control" id="search" placeholder="Search" [(ngModel)]="this.searchText" (ngModelChange)="this.onSearchChange()">
          <label for="search">Search by name or ID:</label>
        </div>
        <div class="small text-muted mb-2">{{this.filteredEmployees.length}} employees</div>
        <div class="list-group overflow-auto flex-grow-1">
          @for (employee of this.filteredEmployees; track employee.uid) {
          <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between gap-2" [class.active]="employee.uid === this.selected?.uid" (click)="this.onEmployeeClick(employee)">
            <span>{{this.employeeName(employee)}}</span>
            <span class="opacity-75">{{employee.employeeNumber}}</span>
          </button>
          } @empty {
          <div class="list-group-item text-center">
            @if (this.isLoading) {
            Loading...
            } @else {
            No Employees
            }
          </div>
          }
        </div>
      </div>
    </div>
    <main class="col-md-8 ms-sm-auto col-lg-9 px-md-4" style="height: calc(100vh - 64px); overflow-y: auto;">
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 border-bottom">
        <h1 class="h2" style="white-space: nowrap;">Permissions</h1>
        <div class="d-flex align-items-center gap-2">
          @if (this.isLoading || this.isLoadingEmployee || this.isSaving) {
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
          }
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="this.onBackClick()">Back</button>
        </div>
      </div>
      @if (this.selected) {
      <div class="pt-3">
        <h5 class="mb-0">{{this.employeeName(this.selected)}}</h5>
        <div class="text-muted mb-3">{{this.selected.employeeNumber}}</div>
        @for (type of this.permissionTypes; track type.id) {
        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" [id]="'permission-' + type.id" [ngModel]="this.checked[type.id] || this.isLockedBySuperAdmin(type.id)" (ngModelChange)="this.checked[type.id] = $event" [disabled]="this.isLoadingEmployee || this.isSaving || this.isLockedBySuperAdmin(type.id)">
          <label class="form-check-label" [for]="'permission-' + type.id">
            {{type.name}}
            <div class="small text-muted">{{type.description}}</div>
            @if (this.isLockedBySuperAdmin(type.id)) {
            <div class="small text-muted">Included with Super Admin.</div>
            }
          </label>
        </div>
        }
        <button type="button" class="btn btn-primary" (click)="this.onSaveClick()" [disabled]="this.isLoadingEmployee || this.isSaving">Save</button>
      </div>
      } @else {
      <div class="pt-3 text-muted">Select an employee to see their permissions.</div>
      }
    </main>
  </div>
</div>
